import { createContext } from "react";
const TextAncestorContext = createContext(false);
export {
  TextAncestorContext
};
//# sourceMappingURL=TextAncestorContext.js.map
